if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.submitButton = this.querySelector('[type="submit"]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            // Announce the successful add from this form, with the line Shopify
            // returned, before cartAdd re-renders the mini-cart and replaces
            // this element. The mini-cart upsell tracking listens for it.
            if (!this.error) {
              this.dispatchEvent(
                new CustomEvent("product-form:added", { bubbles: true, detail: response })
              );
              publish(PUB_SUB_EVENTS.cartAdd);
            }
            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");

            const addButtons = document.querySelectorAll(".js-add-button");
            if (addButtons.length) {
              addButtons.forEach((button) => {
                button.classList.remove("loading");
              });
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.stickyAddToCart = document.querySelector('sticky-add-to-cart');
  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionsRadios();
    this.updateMasterId();
    this.toggleAddButton(true, false, true);
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.synchroniseOptions();

    if (!this.currentVariant) {
      this.toggleAddButton(true, true, false);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateFabricModalTitle();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateOptionsRadios() {
    const fieldsets = document.querySelectorAll('product-form fieldset.js.product-form__input');

    this.options.forEach((opt, i) => {
      const radios = fieldsets[i].querySelectorAll('input[type="radio"]')
      
      radios.forEach((radio) => {
        if (radio.value === opt) {
          radio.checked = true;
        }
      })
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    const productSection = document.querySelector(".js-product-section");
    if (!productSection) return;
    const addButtons = productSection.querySelectorAll("add-product");
    if (!addButtons.length) return;
    addButtons.forEach((button) => {
      button.setAttribute("data-id", this.currentVariant.id);
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        if (window.variantStrings.unavailable_with_option) {
          input.innerText = window.variantStrings.unavailable_with_option.replace(
            "[value]",
            input.getAttribute("value")
          );
        }
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        
        const section = document.getElementById(
          `shopify-section-${this.dataset.section}`
        );

        const newPrice = html.querySelector(`.price-${this.dataset.section}`);
        
        const prices = section.querySelectorAll(
          `.price-${this.dataset.section}`
        );

        const stickyBarPrice = section.querySelector('.js-sticky-bar-product-price');

        prices.forEach((priceElement) => {
          priceElement.innerHTML = newPrice.innerHTML;
        });

        if (stickyBarPrice && newPrice) {
          const price = newPrice.querySelector('.price').getAttribute('data-price-with-currency');
          stickyBarPrice.innerText = price;
        }

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );

        this.toggleAddButton(
          addButtonUpdated
            ? addButtonUpdated.classList.contains("sold-out")
            : true
        );
      });
  }

  toggleAddButton(disable = true, modifyClass = true, loading = false) {
    const productSection = document.querySelector(".js-product-section");
    if (!productSection) return;
    const addButtons = productSection.querySelectorAll(".js-add-button");
    if (!addButtons.length) return;

    if (loading) {
      addButtons.forEach((button) => {
        button.classList.add("loading");
      });
      return;
    }

    // The delivery box follows Add to Basket. Placed after the `loading`
    // early-return above on purpose: a variant switch in progress disables the
    // button briefly, and the panel should not blink out while that happens.
    const deliveryBox = document.querySelector("[data-pdp-delivery]");
    if (deliveryBox) deliveryBox.hidden = disable;

    addButtons.forEach((button) => {
      const addButtonText = button.querySelector("span");
      if (disable) {
        button.disabled = true;
        if (addButtonText) {
          addButtonText.textContent = window.variantStrings.soldOut;
        }
      } else {
        button.removeAttribute('disabled');
        if (addButtonText) {
          // Restores whatever this button's label should currently be, not the
          // generic wording. updateAddButton() records that on the span, because
          // this method also runs from renderProductInfo() *after* its fetch
          // resolves — i.e. after the click handler — and would otherwise
          // overwrite "Pre-order" with "Add to basket" a moment later.
          addButtonText.textContent =
            addButtonText.dataset.currentLabel || window.variantStrings.addToBag;
        }
      }
      button.classList.remove("loading");
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const productSection = document.querySelector(".js-product-section");
    if (!productSection) return;
    const addButtons = productSection.querySelectorAll('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButtons.length) return;
    addButtons.forEach((button) => {
      const addButtonText = button.querySelector("span");
      addButtonText.textContent = window.variantStrings.unavailable;
    });

    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateFabricModalTitle() {
    const titleToUpdate = document.querySelector('.js-variant-title');
    if (!titleToUpdate) return;
    const title = this.currentVariant.title;
    titleToUpdate.innerText = title;
  }

  synchroniseOptions() {
    const stickyVariants = document.querySelector('sticky-add-to-cart variant-selects');
    const stickyVariantOptions = stickyVariants.querySelectorAll('select');

    if (stickyVariantOptions) {
      stickyVariantOptions.forEach((option, idx) => option.value = this.options[idx]);
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.featuredImageSources = document.querySelectorAll('#productMainSlider .js-carousel-slide:first-child picture > *');
    this.thumbImg = document.querySelector('#productThumbSlider .js-carousel-slide:first-child img');
    this.deliveryInfo = document.querySelector('.delivery-time__title .js-delivery-time');
    this.deliveryLabel = document.querySelector('.delivery-time__title .js-delivery-label');
    this.deliveryInfoAccordionContent = document.querySelector('span.delivery-time-accordion-content');
    this.deliveryBox = document.querySelector('[data-pdp-delivery]');
    this.deliveryNote = document.querySelector('[data-pdp-delivery-note]');
    this.listeners();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateImage(event) {
    const mediaId = event.target.closest('[data-media-id]')?.dataset.mediaId;
    if (!mediaId) return;

    const mainSlider = document.querySelector('#productMainSlider');
    const targetSlide = mainSlider?.querySelector(`[data-media-id="${mediaId}"]`);
    
    if (targetSlide) {
      const slideIndex = targetSlide.dataset.slideIndex;
      if (mainSlider && typeof mainSlider.scrollToSlide === 'function') {
        mainSlider.scrollToSlide(slideIndex);
      }
    }
  }

  updateDelivery(event) {
    const deliveryInfo = event.target.dataset.deliveryInfo;
    const deliveryLabel = event.target.dataset.deliveryLabel;
    const deliveryState = event.target.dataset.deliveryState;
    const deliveryNote = event.target.dataset.deliveryNote;

    if (deliveryLabel !== undefined && this.deliveryLabel) {
      this.deliveryLabel.innerText = deliveryLabel;
    }

    // The delivery box carries a pre-order state of its own — the supporting
    // note and the panel styling both change with it, so they have to follow
    // the variant rather than staying on whatever rendered first.
    if (deliveryState !== undefined && this.deliveryBox) {
      this.deliveryBox.dataset.deliveryState = deliveryState;
      this.deliveryBox.classList.toggle('pdp-delivery--labelled', deliveryState === 'labelled');
      this.deliveryBox.classList.toggle('pdp-delivery--standard', deliveryState !== 'labelled');
    }

    if (deliveryNote !== undefined && this.deliveryNote) {
      this.deliveryNote.innerText = deliveryNote;
    }

    if (!deliveryInfo || !this.deliveryInfo) return;

    this.deliveryInfo.innerText = deliveryInfo;
    if (this.deliveryInfoAccordionContent) {
      this.deliveryInfoAccordionContent.innerText = deliveryInfo;
    }
  }

  updateBadge(event) {

    if (event.target.nodeName != 'LABEL') return;

    const badge = document.querySelector('.product .product__label span');

    if (!badge) return;
    
    const badgeTitle = event.target.dataset.badgeTitle;
    const badgeColor = event.target.dataset.badgeColor;
    const badgeBgColor = event.target.dataset.badgeBgColor;

    if ( badgeTitle ) {
      badge.style = "display: flex;"
      badge.innerText = badgeTitle;
      badge.style.color = badgeColor;
      badge.style.backgroundColor = badgeBgColor;
    }else{
      badge.style = "display: none;"
    }
  }

  updateAddButton(event) {
    if (event.target.nodeName !== 'LABEL') return;

    // Empty means this variant is not on pre-order, so every add button goes
    // back to its own wording rather than a shared one — the main button says
    // "add to basket" and the sticky bar "add to bag". Stashing each button's
    // own text the first time it is touched is what lets a single attribute
    // drive both without flattening that difference.
    const preOrderLabel = event.target.dataset.addLabel || '';

    document.querySelectorAll('.js-add-label').forEach((span) => {
      if (span.dataset.defaultLabel === undefined) {
        span.dataset.defaultLabel = span.textContent.trim();
      }
      const nextLabel = preOrderLabel || span.dataset.defaultLabel;
      // Remembered on the element, not just written, so toggleAddButton() can
      // put the right label back after a sold-out variant has replaced it —
      // and so its own later call cannot undo this one. See the note there.
      span.dataset.currentLabel = nextLabel;
      span.textContent = nextLabel;
    });
  }

  updateBespokeForm(event) {
    if (event.target.nodeName !== 'LABEL') return;
    // update the information in the hidden field with product details
    const bespokeHiddenField = document.getElementById('bespoke-form-product-details');
    if (!bespokeHiddenField) return;

    // replace the value of the hidden field with the contents of data-bespoke-product-details
    const details = (event.target.dataset.bespokeProductDetails || '').trim();
    bespokeHiddenField.style = "display: block; width: 100%; outline:2px solid green;";
    bespokeHiddenField.value = details;
  }

  listeners() {
    this.addEventListener('click', event => {
      this.updateDelivery(event);
      this.updateImage(event);
      this.updateBadge(event);
      this.updateAddButton(event);
      this.updateBespokeForm(event);
    });
  }
}

customElements.define('variant-radios', VariantRadios);